import { useContext } from "react";

import { LayoutContext } from "./context/LayoutContext";

const Content = ({ children }) => {
  const { layoutState } = useContext(LayoutContext);

  return (
    <div
      style={{
        ...styles.content,
        marginLeft: layoutState.sidebarVisible ? "22rem" : 0,
        paddingBottom: "4rem",
      }}
      className="wrapper d-flex flex-column"
    >
      <div className="body flex-grow-1 px-3">{children}</div>
    </div>
  );
};

const styles = {
  content: {
    marginBottom: "4rem",
    transition:
      "margin-left .15s,margin-right .15s,box-shadow 75ms,transform .15s,width .15s,z-index 0s ease .15s",
  },
};

export default Content;
